import { defineMessages } from 'react-intl';

export default defineMessages({
  UPDATE_LEARNING_RESOURCE: {
    defaultMessage: 'Mettre à jour la ressource',
  },
} as const);
